module.exports = __webpack_public_path__ + "img/Classifieds Banner.15257744.jpg";